<template>
  <div class="doclib-page-dialog">
    <div class="content-dialog">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonPageDialog',
  props: {

  },
  data () {
    return {

    }
  },
  created () {

  },
  computed: {

  },
  watch: {
  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style lang="postcss" scoped>
@import 'variables';

.doclib-page-dialog {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 10000;
  top: 0;
  left: 0;
  background: #fff;

  & .content-dialog {
    width: 100%;
    height: 100%;
  }
}
</style>
